import {
  GetTokenOptions,
  ILogProvider,
} from '@sennder/senn-node-microfrontend-interfaces'

export const wrapAuthWithLogging = (
  func: (options?: GetTokenOptions) => Promise<string | null>,
  logger: ILogProvider
) => {
  const wrappedFunction: (
    options?: GetTokenOptions
  ) => Promise<string | null> = async (...args) => {
    logger.info('[Legacy Auth Attempt]', {
      args,
    })
    return await func(...args)
  }

  return wrappedFunction
}

export const whenIdle = (callback: () => void, timeout = 1000) => {
  if ('requestIdleCallback' in window) {
    requestIdleCallback(callback, { timeout })
  } else {
    setTimeout(callback, 1)
  }
}
